module.exports = __webpack_public_path__ + "images/mmm-01-desktop.png";